<script setup>
import MobileBottomNav from './MobileBottomNav.vue';

const emit = defineEmits(['toggleMobileSidebar']);

const handleToggleSidebar = () => {
  emit('toggleMobileSidebar');
};
</script>

<template>
  <div class="flex h-full w-full flex-col bg-n-solid-1">
    <section
      class="flex-1 min-h-0 bg-n-background overflow-y-auto no-scrollbar"
    >
      <slot />
    </section>
    <MobileBottomNav @toggle-sidebar="handleToggleSidebar" />
  </div>
</template>
